import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import routes, { adminPages, flattenRoutes } from "routes.js";
import { getToken } from "utils/authStorage";
import EnquiryView from "views/admin/enquiries/view";
import ArticleEditPage from "views/admin/articles/edit";
import CaseEditPage from "views/admin/cases/edit";
import NewsletterIssueEditPage from "views/admin/newsletter-issues/edit";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Header");

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const getActiveRoute = (list) => {
    let activeRoute = "Header";
    flattenRoutes(list).forEach((route) => {
      if (!route.layout || !route.path) return;
      const full = `${route.layout}/${route.path}`;
      if (location.pathname === full || location.pathname.startsWith(`${full}/`)) {
        activeRoute = route.menuLabel || route.name;
      }
    });
    setCurrentRoute(activeRoute);
    return activeRoute;
  };
  const getActiveNavbar = (list) => {
    const match = flattenRoutes(list).find(
      (route) =>
        route.path && window.location.href.indexOf(`${route.layout}${route.path}`) !== -1
    );
    return match?.secondary || false;
  };
  const getRoutes = (list) =>
    adminPages(list).map((prop) => (
      <Route path={`/${prop.path}`} element={prop.component} key={prop.path} />
    ));

  document.documentElement.dir = "ltr";
  if (!getToken()) {
    return <Navigate to="/auth/sign-in" replace />;
  }
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Kodeera"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              {...rest}
            />
            <div className="mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}
                <Route path="/enquiries/:id" element={<EnquiryView />} />
                <Route path="/articles/new" element={<ArticleEditPage />} />
                <Route path="/articles/:id" element={<ArticleEditPage />} />
                <Route path="/cases/new" element={<CaseEditPage />} />
                <Route path="/cases/:id" element={<CaseEditPage />} />
                <Route path="/newsletter-issues/new" element={<NewsletterIssueEditPage />} />
                <Route path="/newsletter-issues/:id" element={<NewsletterIssueEditPage />} />

                <Route
                  path="/"
                  element={<Navigate to="/admin/header" replace />}
                />
                <Route
                  path="/default"
                  element={<Navigate to="/admin/header" replace />}
                />
                <Route
                  path="/basic"
                  element={<Navigate to="/admin/header" replace />}
                />
              </Routes>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
